var SiteAnalytics = (function () {
    var e = RegExp("/" + window.location.host + "/"),
        t = /\.(zip|exe|pdf|doc*|xls*|ppt*|mp3)$/i,
        n = RegExp("^(tel):", "i"),
        i = RegExp("^(https?:\\/\\/)?((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*(\\?[;&a-z\\d%_.~+=-]*)?(\\#[-a-z\\d_]*)?$", "i"),
        o = function () {
            var o, u, f;
            $("#shopify-section-header").find(".navigation--main").on("click", "a", v),
            $("#shopify-section-footer").find(".section-footer__lower-menu__list").on("click", "a", w),
            $(".template-product .product-form").find(".product-link").on("click", z),
            $(".template-product .product-form").find(".product-detail-accordion").on("click", y),
                (o = $("#shopify-section-footer")).find(".section-footer__menu-block__menu").on("click", "a", l),
                o.find(".social-links__list").on("click", "a", s),
                (u = $(".slideshow")).length > 0 &&
                    (u.on("click", ".slick-prev", function () {
                        c("Previous");
                    }),
                    u.on("click", ".slick-next", function () {
                        c("Next");
                    })),
                (f = $(".owl-carousel")).length > 0 &&
                    (f.on("click", ".owl-prev", function () {
                        c("Previous");
                    }),
                    f.on("click", ".owl-next", function () {
                        c("Next");
                    })),
                $("#recently-viewed-products").on("click", "a", a);
        };
    function a(e) {
        var t = $(this).find(".product-block__title").text();
        window.dataLayer.push({ event: "site:RecentlyViewed", event_params: { product_name: t } });
    }
    function c(e) {
        r({ eventCategory: "Site Navigation", eventAction: "Carousel Scroll", eventLabel: e, eventvalue: "", event: "site:Carousel" });
    }
    function v(e) {
        var t = $(this),
            n = t.text();
        console.log(n), r({ eventCategory: "Site Navigation", eventAction: "Main Navigation", eventLabel: t.parents("li").last().find("a:first").text() + "|" + n, eventvalue: "", event: "site:MainNav" });
    }
    function w(e) {
        var t = $(this),
            n = t.text();
        console.log(n), r({ eventCategory: "Site Navigation", eventAction: "Footer", eventLabel: n, eventvalue: "", event: "site:LowerFooter" });
    }
  function z(e) {
        var t = $(this),
        n = t.text();
        console.log(n), r({ eventCategory: "PDP", eventAction: "Related", eventLabel: t.parents(".product-block").find(".product-block__title").text(), eventvalue: "", event: "pdp:Related" });
    }
   function y(e) {
        var t = $(this),
        n = $(this).find(".with-icon__beside").text();
        console.log(n), r({ eventCategory: "PDP", eventAction: "Accordion", eventLabel: n, eventvalue: "", event: "pdp:Accordion" });
    }
    function l(e) {
        u(this.innerText);
    }
    function s(e) {
        u($(this).data("type"));
    }
    function u(e) {
        r({ eventCategory: "Site Navigation", eventAction: "Footer", eventLabel: e, eventvalue: "", event: "site:Footer" });
    }
    function r(e) {
        (window.dataLayer || []).push(e);
    }
    return { init: o };
})();
$(function () {
    SiteAnalytics.init();
});
